export enum TagType {
	EVENT = 'event',
	TICKET_TYPE = 'ticket_type',
}

export interface CreateTagRequest {
	name: string;
	color?: string;
	description?: string;
	tag_type: TagType;
}

export interface AddTagsRequest {
	tag_ids: number[];
}

export interface RemoveTagsRequest {
	tag_ids: number[];
}
